import { MenuItem, Select, Stack, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { createNotice, getChannels } from "../../api"
import { useSnackbar } from "notistack"

const AddNotice = (props) => {
  const [channels, setChannels] = useState([])

  const fetchChannels = () => {
    getChannels()
      .then((res) => setChannels(res.data.rows))
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    fetchChannels()
  }, [])

  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState({
    channelId: "",
    title: "",
    content: "",
    image: "",
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setData({
      ...data,
      [name]: value,
    })
  }

  const handleSubmit = () => {
    setLoading(true)
    createNotice(data)
      .then(() => {
        enqueueSnackbar("Notice added.", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      {...props}
      title="Add Notice"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Channel">
            <Select
              name="channelId"
              value={data.channelId}
              onChange={handleChange}
            >
              {channels.map((c) => (
                <MenuItem value={c.id}>{c.name}</MenuItem>
              ))}
            </Select>
          </FormItem>
          <FormItem label="Title">
            <TextField
              name="title"
              value={data.title}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Content">
            <TextField
              name="content"
              value={data.content}
              onChange={handleChange}
              multiline
              rows={5}
            />
          </FormItem>
          <FormItem label="Image link">
            <TextField
              name="image"
              value={data.image}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
      </Stack>
    </Modal>
  )
}

export default AddNotice
